import React, { Component } from 'react';
import { Fragment } from 'react';
import {DataRPC, News, ImageText, Services} from '../../rpc-client/DataRPC';
import ReactHtmlParser from "react-html-parser";
import './DetailPage.css';

class ServiceDetails extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            content: "",
            name: "",
            create_date: "",
            description: "",
            ava: "",
            
            service_title: "",
            service_desc: "",
            service_image: ""
        }
    }

    async componentDidMount() {

        let id = this.props.match.params.id;

        new DataRPC().fetchData('GetServices', {
            id: id
        }, Services).then(gData => { 
            if (gData) {
                console.log(gData);

                this.setState({
                    content: gData.content,
                    name: gData.name,
                    create_date: gData.create_date,
                    description: gData.description,
                    ava: gData.img
                });
            }
        });

        new DataRPC().fetchData('GetImageText', {
            page: "service"
        }, ImageText).then(gData => { 
            if (gData) {
                this.setState({service_title: gData.find(x => x.komoku == "service_title").content});
                this.setState({service_desc: gData.find(x => x.komoku == "service_desc").content});
                this.setState({service_image: gData.find(x => x.komoku == "service_image").content});
            }
        });
    }

    render() {
        return( 
            <Fragment>

                <section className="hc-detail-hero" style={{backgroundImage: `url(${this.state.service_image})`}}>
                    <div className="hc-container">
                        <div className="hc-detail-hero-inner">
                            <span>{this.state.service_title}</span>
                            <h1>{this.state.service_desc}</h1>
                        </div>
                    </div>
                </section>

                <section className="hc-detail-body">
                    <div className="hc-container">
                        <div className="hc-detail-card">
                            <img src={this.state.ava} alt=""/>

                            <div className="hc-detail-content">
                                <div className="hc-detail-meta">
                                    <span><i className="icofont-book-mark"></i> Tin tức</span>
                                    <span><i className="icofont-calendar"></i> {this.state.create_date}</span>
                                </div>

                                <h2>{this.state.name}</h2>

                                <p className="hc-detail-lead">{this.state.description}</p>

                                <div className="hc-detail-prose">
                                    {ReactHtmlParser(this.state.content)}
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </Fragment>
        )
    }

}

export default ServiceDetails;